import React from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
`;

const FailureIcon = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto;
  position: relative;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

const ExclamationCircle = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #dc3545;
  background-color: #dc3545;
`;

const ExclamationDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
`;

const ExclamationLine = styled.div`
  width: 8px;
  height: 30px;
  background-color: white;
  border-radius: 4px;
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
`;

const FailureTitle = styled.h2`
  color: #dc3545;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 10px;
  text-align: center;
`;

const FailureMessage = styled.p`
  color: #666;
  font-size: 16px;
  text-align: center;
  margin: 0;
`;

function PaymentFailure() {
  return (
    <Container>
      <FailureIcon>
        <ExclamationCircle>
          <ExclamationDot />
          <ExclamationLine />
        </ExclamationCircle>
      </FailureIcon>
      <FailureTitle>Payment Failed!</FailureTitle>
      <FailureMessage>We couldn&apos;t process your payment. Please try again.</FailureMessage>
    </Container>
  );
}

export default PaymentFailure; 